import { DateTime } from "luxon";

function padded(strings: TemplateStringsArray, ...variables: any[]): string {
    const u: string[] = [];

    u.push(strings[0]);
    u.push(variables[0].toString());

    for (let i = 1; i < variables.length; i++) {
        u.push(strings[i]);
        u.push(variables[i].toString().padStart(2, '0'));
    }

    u.push(strings[strings.length - 1]);

    return u.join('');
}

function parseAndNormalize(h: string, m: string, s: string, am: boolean, pm: boolean): { hours: number, minutes: number, seconds: number } {
    const hours = parseInt(h || '0', 10);
    const minutes = parseInt(m || '0', 10);
    const seconds = parseInt(s || '0', 10);

    return {
        hours: (pm && hours !== 12 ? 12 : 0) + (hours === 12 && am ? 0 : hours) + Math.floor(minutes / 60),
        minutes: minutes % 60 + Math.floor(seconds / 60),
        seconds: seconds % 60
    };
}

// formats a given string as a "time" (e.g. "03:45"), optionally including seconds and/or clamping hours to 0-23 (i.e. time of day)
export function timeFormat(timeInput: string | DateTime, includeSeconds: boolean = false, clampHours: boolean = true): string {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (!timeInput) {
        // use zeros
    }
    else if (DateTime.isDateTime(timeInput)) {
        hours = timeInput.hour;
        minutes = timeInput.minute;
        seconds = timeInput.second;
    }
    else if (timeInput.includes(':')) {
        const parts = timeInput.match(/^(\d*):(\d*)(?::(\d*(?:\.\d+)?))?/);
        const pm = !!timeInput.match(/P/i);
        const am = !!timeInput.match(/A/i);

        ({ hours, minutes, seconds } = parseAndNormalize(parts[1], parts[2], parts[3], am, pm));
    }
    else if (timeInput.includes('.') || timeInput.includes(',')) {
        let rem = parseFloat(timeInput.replace(',', '.'));
        hours = Math.floor(rem);

        rem = (rem - hours) * 60;
        minutes = Math.floor(rem);

        rem = (rem - minutes) * 60;
        seconds = Math.floor(rem);
    }
    else {
        let timedigits = timeInput.replace(/\D/g, '').substring(0, 6);
        const pm = !!timeInput.match(/P/i);
        const am = !!timeInput.match(/A/i);

        if (timedigits.length) {
            if (timedigits.length % 2 === 1)
                timedigits = '0' + timedigits;

            const parts = timedigits.match(/^(\d\d)(\d\d)?(\d\d)??$/);

            ({ hours, minutes, seconds } = parseAndNormalize(parts[1], parts[2], parts[3], am, pm));
        }
    }

    if (clampHours)
        hours = hours % 24;

    return includeSeconds
        ? padded`${hours}:${minutes}:${seconds}`
        : padded`${hours}:${minutes}`;
}
